import _regeneratorRuntime from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\projects\\suseval\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
// import Platform from 'quasar/src/plugins/Platform.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';
// import { initializeDb } from 'abi/database'
// import Pomodoro from 'lib/pomodoro'
// import Preferences from 'lib/preferences'
//
// import { PremiumFlagKey } from 'lib/boot/utils'
//
// import { productName, version } from 'app/package.json'
//
// require('lib/boot')
//
import CommonDialogs from 'lib/dialogs'; //
// import {
//   inMinutes,
//   inHours,
//   padZero,
//   elapsedTime,
//   formatDate,
//   shortenNum
// } from 'lib/utils'
//
// const initializeFilters = (Vue) => {
//   Vue.filter('inMinutes', inMinutes)
//   Vue.filter('inHours', inHours)
//   Vue.filter('elapsedTime', elapsedTime)
//   Vue.filter('padZero', padZero)
//   Vue.filter('formatDate', formatDate)
//   Vue.filter('shortenNum', shortenNum)
// }
//
// const iap = {
//   store: window.store,
//   productId: process.env.IAP_PRODUCT_ID,
//   product: {}
// }
//
// if (Platform.is.capacitor) {
//   iap.store.when(iap.productId).updated(p => (iap.product = p))
// }
//
// export default async ({ Vue, store }) => {
//   initializeFilters(Vue)
//   await initializeDb()
//
//   const preferences = new Preferences(store)
//   const pomodoro = new Pomodoro(store, preferences)
//
//   Vue.prototype.$o = {
//     pomodoro,
//     preferences,
//     tearDown () {
//       pomodoro.tearDown()
//     },
//     dialog: CommonDialogs,
//     app: {
//       name: productName,
//       version,
//       isPremium: () => {
//         return process.env.DEV ||
//           LocalStorage.getItem(PremiumFlagKey).current === true
//       }
//     },
//     iap
//   }
// }

export default
/*#__PURE__*/
(function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var Vue, store;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Vue = _ref.Vue, store = _ref.store;

            /* initializeFilters(Vue)
            await initializeDb()
             const preferences = new Preferences(store)
            const pomodoro = new Pomodoro(store, preferences) */
            Vue.prototype.$o = {
              /* pomodoro,
              preferences,
              tearDown () {
                pomodoro.tearDown()
              }, */
              dialog: CommonDialogs,
              app: {
                name: 'TODO MVD9' // version'TODO MVD9',

                /* isPremium: () => {
                  return process.env.DEV ||
                    LocalStorage.getItem(PremiumFlagKey).current === true
                } */

              }
            };

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();